type BigQueryField = {
    name: string;
    type: string;
    mode?: string;
    fields?: BigQueryField[];
  };
  
  type BigQueryValue = {
    v: any;
  };
  
  function parseAndConvert(field: BigQueryField, value: BigQueryValue): any {
    if (value.v === null || value.v === undefined) {
      return null;
    }
  
    // Handle repeated fields (arrays)
    if (field.mode === 'REPEATED') {
      return (value.v as BigQueryValue[]).map((item) =>
        parseAndConvert(
          { ...field, mode: 'NULLABLE' }, 
          item
        )
      );
    }
  
    // Handle nested RECORD types
    if (field.type === 'RECORD') {
      const obj: Record<string, any> = {};
      field.fields?.forEach((nestedField, index) => {
        const nestedValue = value.v.f[index];
        obj[nestedField.name] = parseAndConvert(nestedField, nestedValue);
      });
      return obj;
    }
    const primitive = value.v;
  
    // Convert ISO date strings to Date objects if you want, or keep as string
    // Here we keep strings as is, but you can parse dates if needed
    if (typeof primitive === 'string') {
      return primitive;
    }
    if (
      typeof primitive === 'number' ||
      typeof primitive === 'boolean'
    ) {
      return primitive;
    }
    
    return String(primitive);
  }
  
  export function parseBigQueryRows(
    fields: BigQueryField[],
    rows: { f: BigQueryValue[] }[]
  ): any[] {
    return rows.map((row) => {
      const obj: Record<string, any> = {};
      fields.forEach((field, index) => {
        obj[field.name] = parseAndConvert(field, row.f[index]);
      });
      return obj;
    });
  }
  